import {PipelineEntity} from "@ots-frontend/ots-data";
import {BaseEntityMultiSelect, BaseEntityMultiSelectProps} from "../base-entity-multi-select";

export type BasePipelineMultiSelectProps = BaseEntityMultiSelectProps<PipelineEntity>;

export const BasePipelineMultiSelect = (props: BasePipelineMultiSelectProps) => {
  return <BaseEntityMultiSelect {...props} />;
};
